import React from 'react';
import { Navigate} from 'react-router-dom';
import { connect } from 'react-redux'



const FrontendAuth = (props) => {
    return props.login ? props.component : <Navigate to="/login"/>
}
const stateToProps = (state) =>{
    return{
        login: state.login
    }
}

const dispathToProps = () =>{return{}}

export default connect(stateToProps, dispathToProps)(FrontendAuth);
